<template>
  <div class="article-edit-container">
    <div>
      <bread-crumb />
    </div>
    <div class="global-table-container">
      <basic-form
        ref="basicForm"
        :form-data="formData"
      >
        <template #company_id>
          <a-select
            v-decorator="['company_id',{rules: [
              { required: true, message: '请选择企业' },
            ],initialValue:data.company_id}]"
            placeholder="请选择企业"
          >
            <a-select-option
              v-for="item in companyData"
              :key="item.id"
              :value="item.id"
            >
              {{ item.companyInfo.qichacha_name }}
            </a-select-option>
          </a-select>
        </template>
		<template #product_id>
				  <a-select
				    v-decorator="[
				      'product_id',
				      { rules: [{ required: true, message: '请选择关联产品' }],initialValue:data.product_id },
				    ]"
				    placeholder="请选择关联产品"
				  >
				   <a-select-option
				     v-for="item in productData"
				     :key="item.id"
				     :value="item.id"
				   >
				     {{ item.title }}
				   </a-select-option>
				  </a-select>
		</template>
        <!-- <template #group_id>
          <a-tree-select
            v-decorator="['group_id',{rules: [
              { required: true, message: '请选择栏目' },
            ],initialValue:data.group_id?String(data.group_id):undefined}]"
            class="select-container"
            :tree-data="parentData"
            placeholder="请选择栏目"
          />
        </template> -->
        <template #name>
          <a-input
            v-decorator="['name',{rules: [
              { required: true, message: '请输入标题' },
            ],initialValue:data.name}]"
            placeholder="请输入标题"
          />
        </template>
        <template #post_excerpt>
          <a-input
            v-decorator="['post_excerpt',{rules: [
              { required: true, message: '请输入摘要' },
            ],initialValue:data.post_excerpt}]"
            placeholder="请输入摘要"
          />
        </template>
        <template #post_content>
          <div
            ref="editor"
            class="content"
          />
          <div
            v-show="isContent"
            class="content-error"
          >
            请输入内容
          </div>
        </template>
        <template #thumbnail>
          <a-upload
            v-decorator="[
              'thumbnail',
              {
                initialValue: data.thumbnail,
                rules: [{ required: true, message: '请上传图片' }] ,
                valuePropName: 'fileList',
                getValueFromEvent: normFile,
              },
            ]"
            name="upload"
            accept=".jpg, .png, .jpeg"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :data="{fileType:'img',}"
            :action="`${uploadUrl}fileup/up`"
            :before-upload="beforeUpload"
          >
            <img
              v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('thumbnail').length === 1 && $refs.basicForm.form.getFieldValue('thumbnail')[0].status === 'done'"
              width="100"
              height="100"
              :src="$refs.basicForm.form.getFieldValue('thumbnail')[0].url"
              alt="avatar"
            >
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                上传
              </div>
            </div>
          </a-upload>
        </template>
        <template #list_order>
          <a-input-number
            v-decorator="['list_order',{rules: [
              { required: true, message: '请输入排序' },
            ],initialValue:data.list_order}]"
            placeholder="请输入排序"
          />
        </template>
      </basic-form>
      <form-button
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancel"
        @onSubmit="handleSubmit"
      />
    </div>
  </div>
</template>
<script>
import {formDataCompany, formDataService } from './../data/index';
import E from 'wangeditor';
export default {
  data() {
    return {
      formData: formDataCompany,
      companyData: [],
      parentData: [],
	  productData:[],
      loading: false,
      btnIsLoading: false,
      editorContent: '',
      isContent: false,
      data: {thumbnail: []},
    };
  },
  created(){
    if (this.$store.state.user.role === 1) {
      this.formData=formDataService;
      this.getCompanyList();
    } else {
      this.formData = formDataCompany;
    }
  },
  async mounted() {
	  // 获取产品
	  this.getProduct();
    // 获取栏目
    this.getParentData();
    // 编辑内容
    let editor = new E(this.$refs.editor);
    editor.customConfig={
      onchange: (html) => {
        this.editorContent = html;
      },
      customUploadImg: async(files, insert)=> {
        console.log('mounted -> files', files);
        let formData=new FormData();
        files.forEach((item)=>{
          formData.append('upload[]', item);
        });

        let result =await this.$http.post('/fileup/uploadMore', formData);
        if(result.data.status===1){
          result.data.data.data_list.forEach((item)=>{
            insert(item);
          });

        }
      },
    };
    editor.create();
    // 回显
    if(this.$route.query.id){
      await this.getData({id: this.$route.query.id});
      await editor.txt.html(this.editorContent);
    }

  },
  methods: {
	  // 获取合作企业
	  async getProduct() {
	    let result = await this.$http.post('/product/getList');
	    if (result.data.status === 1) {
	      this.productData = result.data.data.data_list;
	    }
	  },
    // 回显
    async getData(params){
      let result=await this.$http.post('/portalPost/info', params);
      if(result.data.status===1){
        let temp=result.data.data;
		
        this.data=temp;
        this.$set(this.data, 'thumbnail', [{
          uid: temp.thumbnail,
          url: temp.thumbnail_url,
          status: 'done',
          name: 'img',
        }]);
        this.editorContent=temp.post_content;
		
      }
    },
    normFile(e) {
      if (e && e.file.status === 'uploading') {
        this.loading = true;
      }
      if (e && e.file.status === 'done') {
        const fileList = [
          {
            uid: e.file.response.data.id,
            status: 'done',
            name: 'img',
            url: e.file.response.data.url,
          },
        ];
        this.loading = false;
        return fileList;
      }
      return e.fileList;
    },
    // 上传前
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('图片小于10M！');
      }
      return isLt2M;
    },
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post('/Company/getCooperationCompanyList');
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
      }
    },
    // 递归处理
    dealData(data) {
      data.forEach((item) => {
        item.title = item.name;
        item.key = item.id;
        item.value = String(item.id);
        item.children = item.child_list;
        item.selectable=false;
        if (item.child_list && item.child_list.length > 0) {
          item.child_list.forEach((list)=>{
            list.title = list.name;
            list.key = list.id;
            list.value = String(list.id);
          });
        }
      });
      return data;
    },
    // 获取栏目数据
    async getParentData() {
      let result = await this.$http.post('/portalPost/groupList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.parentData = this.dealData(JSON.parse(JSON.stringify(data)));
      }
    },
    // 提交
    handleSubmit() {
      this.$refs.basicForm.form.validateFields(async(err, values) => {
        console.log('TCL: handleSubmit -> values', values);
        console.log(this.editorContent);
        if(!this.editorContent){
          this.isContent=true;
        }
        if (!err&&this.editorContent) {
          this.isContent=false;
          if (this.$route.query) {
            this.id = this.$route.query.id;
          }
          let data = {
            id: this.id ? this.id : undefined,
            polymorphic_type: values.polymorphic_type,
            company_id: values.company_id,
            group_id: values.group_id,
            name: values.name,
			product_id:values.product_id,
            post_excerpt: values.post_excerpt,
            hits: String(values.hits),
            likes: String(values.likes),
            favorites: String(values.favorites),
            list_order: String(values.list_order),
            thumbnail: values.thumbnail[0].uid,
            post_content: this.editorContent,
          };
          this.btnIsLoading = true;
          let result = await this.$http.post(
            '/portalPost/update',
            data,
          );
          this.btnIsLoading=false;
          if (result.data.status === 1) {
            this.$message.success('操作成功！');
            this.$router.back();
          }
        }
      });
    },
    // 返回
    onCancel() {
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="scss">
.article-edit-container {
  /deep/ .ant-form-item-no-colon {
    .ant-form-item-label {
      text-align: right;
      .ant-form-item-required {
        &::before {
          display: inline-block;
          content: "*";
          color: #f5222d;
          font-size: 14px;
          line-height: 1;
        }
        &::after {
          content: "";
        }
      }
    }
  }
  .content {
    &::before {
      display: inline-block;
      content: "*";
      color: #f5222d;
      font-size: 14px;
      line-height: 1;
      position: absolute;
      left: -48px;
      top: 15px;
    }
  }
    .content-error{
      color: #f5222d;
    }

  .ant-input-number {
    width: 100%;
  }
}

</style>